/**
 *
 * DatePicker
 *
 */
import React, { memo, ReactNode, useMemo } from 'react';
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css'
import './style.css';
import { ReactComponent as CalendarSVG } from 'assets/icons/Calendar.svg';
import classNames from 'classnames';
import { useAuth } from 'core/context/AuthContext/AuthContextProvider';
import dt from 'date-and-time';

interface Props {
  refCalendar?: any;
  refCalendarMenu?: any;
  onChange?: any;
  onCalendarChange: any;
  onClick?: any;
  hideCalendar?: boolean;
  date: Date | undefined;
  label: string;
  placeholder: string;
  component?: ReactNode;
  name: string;
  onBlur?: any;
  error?: any;
  message?: any;
  maxDate?: Date | undefined;
  minDate?: Date;
  activeStartDate?: Date;
  required?: boolean;
  customHeight?: boolean;
  defaultValueNotRequired?: boolean;
  isClearable?: boolean;
  disabled?: boolean;
  disabledDates?: Date[]; 
  is4vh?: boolean;
}

export const DateTime = memo((props: any) => {

  const authData = useAuth();

  const datepickerRef: any = React.useRef(null);

  const handleIconClick = () => {
    datepickerRef.current.setFocus(true);
  };

  const handleChange = (date) => {
    props?.onChange(date)
  }

  const minDateValue = useMemo(
    () => !!props?.minDate ? (props?.minDate).valueOf() : (new Date(1900, 0, 1)).valueOf()
     /*  props?.minDate?.valueOf() ??
      new Date(
        authData?.SELECTED_ACADEMIC_YEAR?.START_DATE || new Date(1900, 0, 1),
      ).valueOf() */,
    [props?.minDate/* , authData */],
  );

  const maxDateValue = useMemo(
    () => !!props?.maxDate ? (props?.maxDate).valueOf() : (dt.addYears(new Date(), 100)).valueOf()
     /*  props?.maxDate?.valueOf() ??
      (!!authData?.SELECTED_ACADEMIC_YEAR?.END_DATE
        ? new Date(authData?.SELECTED_ACADEMIC_YEAR?.END_DATE)
        : dt.addYears(new Date(), 100)
      ).valueOf() */,
    [props?.maxDate/* , authData */],
  );


  const getDayClassName = (date) => {
    if (!props?.disabledDates) return '';
    if (date.getDay() === 0) return 'sunday';
    if (isDisabledDate(date)) return 'disabled-date';
    return '';
  };
  
const isDisabledDate = (date) => {
  if (date.getDay() === 0) return true;
  return props?.disabledDates?.some(
    (disabledDate) =>
      date.getFullYear() === disabledDate.getFullYear() &&
      date.getMonth() === disabledDate.getMonth() &&
      date.getDate() === disabledDate.getDate()
  );
};


  return (
    <div className={` w-full ${props?.customHeight ? `my-0` : `my-1`}`}>
      {!!props?.label && <label
        className={`${props?.labelClassName} inline-block mb-1 text-sm font-[500]`}
      >
        {props?.label}
        {props?.required && (
          <span className={`text-secondary-red ${props?.labelClassName}`}>
            *
          </span>
        )}
      </label>}

      <div
        className={classNames(
          {
            'custom-datepicker-input-table': props?.is4vh,
            'custom-datepicker-input': props?.customHeight,
            'border-secondary-red': props?.error,
          },
          'bg-neutral-light flex justify-between items-center w-full border-[1px] rounded-lg px-1'
        )}
      >

        <div className='cursor-pointer' onClick={handleIconClick}>
          <CalendarSVG />
        </div>
        {/* <DatePicker
          disabled={props?.disabled}
          isClearable={props?.isClearable}
          ref={datepickerRef}
          filterDate={props?.disabledDates 
            ? (date => !isDisabledDate(date))  
            : undefined}
          dayClassName={getDayClassName}
          minDate={minDateValue}
          maxDate={maxDateValue}
          selected={!!props?.value ? new Date(props?.value || new Date()) : (!!props?.defaultValueNotRequired ? undefined : new Date())}
          onChange={handleChange}
          timeInputLabel="Time:"
          dateFormat={!!props?.datewithtime ? "dd/MM/yyyy hh:mm aa" : "dd/MM/yyyy"}
          inputFormat={!!props?.datewithtime ? "dd/MM/yyyy hh:mm aa" : "dd/MM/yyyy"}
          showTimeInput={!!props?.datewithtime}
          peekNextMonth
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          style={{ height: '20px', lineHeight: '20px' }}
        /> */}
        <DatePicker
          disabled={props?.disabled}
          isClearable={props?.isClearable}
          ref={datepickerRef}
          filterDate={props?.disabledDates ? (date => !isDisabledDate(date)) : undefined}
          dayClassName={getDayClassName}
          minDate={minDateValue}
          maxDate={maxDateValue}
          selected={
            !!props?.value ? new Date(props?.value || new Date()) : 
            (!!props?.defaultValueNotRequired ? undefined : new Date())
          }
          onChange={handleChange}
          timeInputLabel="Time:"
          dateFormat={!!props?.datewithtime ? "dd/MM/yyyy hh:mm aa" : "dd/MM/yyyy"}
          inputFormat={!!props?.datewithtime ? "dd/MM/yyyy hh:mm aa" : "dd/MM/yyyy"}
          showTimeInput={!!props?.datewithtime}
          peekNextMonth
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          popperPlacement="bottom-start"
          popperModifiers={[
            {
              name: 'preventOverflow',
              options: {
                boundary: 'viewport',
              },
            },
          ]}
          popperClassName="high-z-index-datepicker"
        />

      </div>
      {!!props?.message && (
        <span
          className={classNames(`${props?.error ? 'text-secondary-red' : 'text-neutral-60'} mt-[4px] text-xs`)}
        >
          {props?.message}
        </span>
      )}
    </div>
  );
});
